export const styles = theme => ({
  textSize: {
    fontSize: theme.constants.fontSizes.small,
  },
});
